<template>
  <div class="systembody">
    <div style="margin-top: 10px;">
      <div class="sectionLargeIcon largeServerIcon"></div>
      <div class="widget clearfix">
        <span class="title" style="font-size: 22px; margin-right: 15px; font-weight: 600 !important; color: #183677;">
          סקרים</span>

        <!-- אדמין: מעבר בין הסקרים של המערכת שלו לבין הנתונים של כל המערכות -->
        <div v-if="isAdmin" class="srv-view-tabs" role="tablist" aria-label="תצוגת הסקרים">
          <button v-for="t in tabs" :key="t.value" type="button" role="tab" class="srv-view-tabs__btn"
            :class="{ 'is-active': view === t.value }" :aria-selected="view === t.value ? 'true' : 'false'"
            @click="setView(t.value)">
            {{ t.label }}
          </button>
        </div>

        <div class="widget_inside" style="margin-top: 15px;">
          <SurveysComp v-show="view === 'mine'" />
          <!-- נטען רק בפעם הראשונה שפותחים את הלשונית, ונשאר טעון במעבר בין הלשוניות -->
          <SurveysAdminStats v-if="isAdmin && statsOpened" v-show="view === 'all'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SurveysComp from '@/components/surveys/SurveysComp'
import SurveysAdminStats from '@/components/surveys/SurveysAdminStats'
import Auth from '@/services/auth.service.js'

export default {
  name: 'surveys',
  components: {
    SurveysComp,
    SurveysAdminStats,
  },
  data: () => ({
    isAdmin: false,
    view: 'mine',
    statsOpened: false,
    tabs: [
      { value: 'mine', label: 'הסקרים שלי' },
      { value: 'all', label: 'כל המערכות' },
    ],
  }),
  methods: {
    setView(value) {
      this.view = value;
      if (value === 'all') this.statsOpened = true;
      // הלשונית נשמרת בכתובת, כך שרענון הדף נשאר באותה תצוגה
      const query = value === 'all' ? { view: 'all' } : {};
      if ((this.$route.query.view || '') !== (query.view || '')) {
        this.$router.replace({ query }).catch(() => { });
      }
    },
  },
  created() {
    document.title = 'סקרים | clickcall'
    let auth = Auth.checkAuth();
    if (!auth) {
      this.$router.replace({ name: "login" })
    }
    this.isAdmin = Auth.getUserRole() === 'admin';
    if (this.isAdmin && this.$route.query.view === 'all') this.setView('all');
  },
}
</script>

<style scoped>
.srv-view-tabs {
  display: inline-flex;
  vertical-align: middle;
  margin-inline-start: 16px;
  background: #e9edf5;
  border-radius: 12px;
  padding: 4px;
  gap: 2px;
}
.srv-view-tabs__btn {
  padding: 6px 16px;
  border-radius: 9px;
  font: 500 14px 'Heebo', sans-serif;
  color: #3d5488;
  transition: background-color .15s, color .15s;
}
.srv-view-tabs__btn:hover { color: #0d2c6d; }
.srv-view-tabs__btn.is-active {
  background: #fff;
  color: #0d2c6d;
  font-weight: 700;
  box-shadow: 0 1px 2px rgba(13, 44, 109, .12);
}
.srv-view-tabs__btn:focus-visible { outline: 2px solid #ffb91a; outline-offset: 2px; }
@media (prefers-reduced-motion: reduce) {
  .srv-view-tabs__btn { transition: none; }
}
</style>